import styled from 'styled-components';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';
import QuIcon from '@quiqupltd/qu-react-sdk/lib/components/qu-icon';

export const Container = styled.div`
  height: 106px;
  padding: 30px 24px 24px 16px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.06);

  ${props => props.isMobile && 'cursor: pointer;'}

  ${media.up('phone')`
    padding: 25px 48px 15px;
    height: 100px;
  `}
`;

export const TextContainer = styled.div`
  float: left;
  width: 90%;
  min-height: 96px;

  ${media.up('phone')`
    float: none;
    width: 100%;
  `};
`;

export const Icon = styled(QuIcon)`
  top: 20px;
  position: relative;

  ${media.up('phone')`
    display: none;
  `};

  svg {
    transition: transform 0.3s;
    ${props => props.isCardOpen && 'transform: rotate(180deg);'};
  }
`;

export const Title = styled.h1`
  font-size: ${pxToRem(20)};
  font-weight: 300;
  line-height: 1.3;
  margin: 0 0 6px 0;
`;

export const SubTitle = styled.h2`
  font-size: ${pxToRem(16)};
  font-weight: 300;
  line-height: 1.25;
  margin: 0;
  color: ${props => props.theme.grey};
`;



// WEBPACK FOOTER //
// ./src/app/order-card/delivery-failed/header/delivery-failed-header.styles.js